module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABJ0lEQVRIie3VQWqDQBQG4H9KFh7BGwTaRSAgSFbeJGCEBFNIjuJS2kULWeQSpslOo1m2Z9AcQBEivK5aWo2d0QgJdN5yZvg/Zpg3w4iIcIW6uwYqYQn/c7jIMmwmcxz3h9o1SRDhzXpEkWX8QBKszWROq/6Q1oMRxX5YmY/9kNaDEa36Q/JMm5snvON7a4yeoqDIc+xmSyRB9Gunu9kSRZ6jpyh4sMbcPNbkySwDhusAQGVM1bVu4XM4gMZoK7iMA2iMAi3biTEmNNYpfNwfsJ0uvo/368Jtp4s/W+0iuIwargPDdVrhwvA5VNU1qLpWwX+22sXw+9NL7e0t4x/Pr/xA0ZfrlKbkmTYlQVS7JvZD8kybTmnKzWvVTl3U7f9OEpawhG8W/gT8JnRKpA6LrwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = 320
// module chunks = 1